module.exports = __webpack_public_path__ + "img/page1-bg-phone.934d57af.png";